import { useTranslation } from 'react-i18next';

const useFooterHook = () => {
  const { t } = useTranslation('translation', { keyPrefix: 'management' });

  return { t };
};

export { useFooterHook };
